import './index.scss'

// 暂时注释掉webmap相关代码以避免与高德地图冲突
/*
import webmap from 'jason-webmap'

webmap({
  // 激活 map 的按钮选择器
  openSelector: '[data-open="map"]',
  // 跟随者 map 一同移动的内容选择器
  moveSelector: '.comp-root'
})
*/
